import axiosInstance from '@/api/axiosInstance';
import { API_ENDPOINTS } from '@/api/endpoints';
import { LoginPayload, LoginResponse, User } from '@/types/auth';

export const authApi = {
    login: async (payload: LoginPayload): Promise<LoginResponse> => {
        const response = await axiosInstance.post(API_ENDPOINTS.USERS.LOGIN, payload);
        return response.data;
    },
    logout: async (): Promise<void> => {
        await axiosInstance.post(API_ENDPOINTS.USERS.LOGOUT);
    },
    getMe: async (): Promise<User> => {
        const response = await axiosInstance.get(API_ENDPOINTS.USERS.ME);
        return response.data;
    },
    updateMe: async ({ id, payload }: { id: number; payload: Partial<User> }): Promise<User> => {
        const response = await axiosInstance.patch(API_ENDPOINTS.USERS.UPDATE(id), payload);
        return response.data;
    },
};
